import $ from 'jquery';
import Glide from '@glidejs/glide'

// grabbing cursor on mousedown
if( $('.glide__slide').length ) {
  $('.glide__slide').on( 'mousedown', function (){
    $( this ).addClass( 'grabbing' )
  })
  $('.glide__slide').on( 'mouseup', function (){
    $( this ).removeClass( 'grabbing' )
  })
}

//featured beer glider
if( $('.hover').length ){
  new Glide('.hover', {
    type: 'carousel',
    startAt: 0,
    perView: 1,
    gap: 100,
    peek: { before: 73, after: 73 }
  }).mount()
}

// single locations image gallery
if( $('.gallery').length ){
  new Glide('.gallery', {
    type: 'carousel',
    startAt: 0,
    perView: 1,
    gap: 100,
    peek: { before: 300, after: 300 },
    breakpoints: {
      1100: { 
       gap: 50,
       peek: { before: 200, after: 200 },
      },
      640: { 
        gap: 20,
        peek: { before: 100, after: 100 },
      }, 
      400: { 
        gap: 20,
        peek: { before: 50, after: 50 },
      } 
    }
  }).mount()
}